import { FactoryTypes, FieldID } from "../../../models";

export const iphoneToSamsungSetupWithPhone = [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.chargeBothPhonesAndBringAdapter,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.doYouKnowAppleIdAndPasswordQuestion,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.findYourAppleId.text,
            image: FieldID.guideContainer.steps.findYourAppleId.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.resetAppleIdPassword.text,
            image: FieldID.guideContainer.steps.resetAppleIdPassword.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.ifTwoFactorEnabled.text,
            image: FieldID.guideContainer.steps.ifTwoFactorEnabled.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.ifTwoFactorDisabled.text,
            image: FieldID.guideContainer.steps.ifTwoFactorDisabled.image,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.haveYouWalkedThroughSetupSteps,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.turnSamsungPhoneOn.text,
            image: FieldID.guideContainer.steps.turnSamsungPhoneOn.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.connectiPhoneToSamsung.text,
            image: FieldID.guideContainer.steps.connectiPhoneToSamsung.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.trustSmartSwitchOnIphone.text,
            image: FieldID.guideContainer.steps.trustSmartSwitchOnIphone.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.makeSelectionAndTransfer.text,
            image: FieldID.guideContainer.steps.makeSelectionAndTransfer.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.bringStuffFromiCloud.text,
            image: FieldID.guideContainer.steps.bringStuffFromiCloud.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.tapImportToTransferData.text,
            image: FieldID.guideContainer.steps.tapImportToTransferData.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.tapDoneToGoToHomeScreen.text,
            image: FieldID.guideContainer.steps.tapDoneToGoToHomeScreen.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.turnOffiMessage.text,
            image: FieldID.guideContainer.steps.turnOffiMessage.image,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
];

export const iphoneToSamsungSetupLostPhone = [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.iphoneToSamsungLostData,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText: FieldID.guideContainer.decisionStep.doYouKnowGooglePassword,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.findGmailAddress.text,
            image: FieldID.guideContainer.steps.findGmailAddress.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.confirmYourAccount.text,
            image: FieldID.guideContainer.steps.confirmYourAccount.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.checkEmailUsernameList.text,
            image: FieldID.guideContainer.steps.checkEmailUsernameList.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.resetGmailPassword.text,
            image: FieldID.guideContainer.steps.resetGmailPassword.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.answerSecurityQuestions.text,
            image: FieldID.guideContainer.steps.answerSecurityQuestions.image,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.haveYouWalkedThroughSetupSteps,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.samsungSetupLetsGo.text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images: FieldID.guideContainer.steps.samsungSetupLetsGo.images,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.samsungCopyAppsAndDataFromIphone
              .text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images:
              FieldID.guideContainer.steps.samsungCopyAppsAndDataFromIphone
                .images,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps
              .samsungSetupFollowOnscreenInstructions.text,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
];

export const telusKoodoIphoneToSamsungSetupLostPhone = [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.iphoneToSamsungLostData,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText: FieldID.guideContainer.decisionStep.doYouKnowGooglePassword,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.TIPBOX,
          fieldMapping: {
            text: FieldID.guideContainer.tipBox.useGoogleAccountNewPhone,
            icon: FieldID.guideContainer.tipBox.icon,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.findGmailAddress.text,
            image: FieldID.guideContainer.steps.findGmailAddress.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.confirmYourAccount.text,
            image: FieldID.guideContainer.steps.confirmYourAccount.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.checkEmailUsernameList.text,
            image: FieldID.guideContainer.steps.checkEmailUsernameList.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.resetGmailPassword.text,
            image: FieldID.guideContainer.steps.resetGmailPassword.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.answerSecurityQuestions.text,
            image: FieldID.guideContainer.steps.answerSecurityQuestions.image,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.haveYouWalkedThroughSetupSteps,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.samsungLetsGoScreen.text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images: FieldID.guideContainer.steps.samsungLetsGoScreen.images,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.samsungCopyAppsData.text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images: FieldID.guideContainer.steps.samsungCopyAppsData.images,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.followInstructionsCompleteSetup
              .text,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
];
